export default __webpack_public_path__ + "assets/images/avatar.fab04d.avif";